import SvgIcon, { SvgIconProps } from "./SvgIcon";

const FlagIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M8.0812 21.894L4.62156 4.36217L16.3992 2L14.8948 7.11892L18.1232 11.1838L6.50255 13.7232M3.09473 22H20.0947"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
    </SvgIcon>
  );
};

export default FlagIcon;
